import { render, staticRenderFns } from "./honorDetail.vue?vue&type=template&id=7c3a37fc&scoped=true"
import script from "./honorDetail.vue?vue&type=script&lang=js"
export * from "./honorDetail.vue?vue&type=script&lang=js"
import style0 from "./honorDetail.vue?vue&type=style&index=0&id=7c3a37fc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3a37fc",
  null
  
)

export default component.exports